// src/utils/analytics.js
export const logEvent = (eventName, params) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", eventName, params);
  }
};

export const CURRENCY = "USD";

// Products and cart lines disagree on what the name field is called: the API
// returns `name`, but CartSlice stores it as `title` (see ProductDisplay's
// addToCart dispatch). Reading only one of them is how every GA4 `purchase`
// event ended up with item_name: undefined, which makes the ecommerce reports
// unusable. Every event goes through here so that class of bug cannot recur.
export const toGa4Item = (item, index) => {
  if (!item) return null;

  const ga4Item = {
    item_id: item.id,
    item_name: item.name ?? item.title,
    item_brand: "Zecado",
  };

  const price = item.hasDiscount ? item.discountedPrice ?? item.price : item.price;
  if (price != null) ga4Item.price = Number(price);
  if (item.quantity != null) ga4Item.quantity = item.quantity;
  if (item.category?.name) ga4Item.item_category = item.category.name;
  if (item.collection?.name) ga4Item.item_category2 = item.collection.name;
  if (typeof index === "number") ga4Item.index = index;

  return ga4Item;
};

export const toGa4Items = (items = []) => items.map(toGa4Item).filter(Boolean);

export const itemsValue = (items = []) =>
  Number(
    items
      .reduce((sum, item) => {
        const price = item.hasDiscount ? item.discountedPrice ?? item.price : item.price;
        return sum + Number(price ?? 0) * Number(item.quantity ?? 1);
      }, 0)
      .toFixed(2)
  );

// Core Web Vitals. reportWebVitals() was previously called with no argument, so
// the metrics were computed on every page load and thrown away. GA4 wants an
// integer, and CLS is a fraction, so it is scaled by 1000 per Google's own
// web-vitals-to-GA4 recipe.
export const sendWebVitalsToGa4 = ({ name, delta, value, id }) => {
  logEvent(name, {
    event_category: "Web Vitals",
    value: Math.round(name === "CLS" ? (delta ?? value) * 1000 : delta ?? value),
    metric_id: id,
    metric_value: value,
    metric_delta: delta,
    non_interaction: true,
  });
};
